/*
function cleanOptionInfoSpans() {
  document.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
    const originalText = span.textContent.trim();
    const cleanedText = originalText.replace(/\s?\(.*$/, '').trim();

    if (originalText !== cleanedText) {
      span.textContent = cleanedText;
      console.log('[cleanup] Cleaned span:', cleanedText);
    }
  });
}

function validateSideColor() {
  const sideOptionInputs = document.querySelectorAll(
    'fieldset:nth-of-type(2) input[type="radio"]'
  );

  const selected = Array.from(sideOptionInputs).find((input) => input.checked);
  if (!selected) {
    console.warn('[variant:change] No side color selected at all.');
    return;
  }

  const selectedLabel = document.querySelector(`label[for="${selected.id}"]`);
  const selectedColor = selectedLabel?.querySelector('.sr-only')?.textContent?.trim() || 'Unknown';
  const isActuallyDisabled =
    selected.disabled ||
    selectedLabel?.classList.contains('is-disabled') ||
    selectedLabel?.getAttribute('aria-disabled') === 'true';

  if (!isActuallyDisabled) {
    console.log(`[variant:change] Side color is valid: ${selectedColor} (ID: ${selected.value})`);
    return;
  }

  const fallback = Array.from(sideOptionInputs).find((input) => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const isDisabled =
      input.disabled ||
      label?.classList.contains('is-disabled') ||
      label?.getAttribute('aria-disabled') === 'true';
    return !isDisabled;
  });

  if (fallback) {
    const fallbackLabel = document.querySelector(`label[for="${fallback.id}"]`);
    const fallbackColor = fallbackLabel?.querySelector('.sr-only')?.textContent?.trim() || 'Unknown';

    console.log(`[variant:change] Switching to fallback side color: ${fallbackColor} (ID: ${fallback.value})`);
    fallback.click();
  } else {
    console.warn('[variant:change] All side color options are disabled.');
  }
}

// Run immediately on page load
cleanOptionInfoSpans();
validateSideColor();

// Run again on variant change
document.addEventListener('variant:change', () => {
  cleanOptionInfoSpans();
  validateSideColor();
});
*/

/* ---------------------------------------------------------
   DEFERRED POPOVER CONTENT
   Large option lists (e.g. the country selector) ship inside
   <template data-deferred-content> to keep them out of the DOM
   until the popover opens. "dialog:before-show" does not bubble,
   so listen during the capture phase. It also fires for the
   dialog containing the popover (e.g. the mobile sidebar), so
   nested lists exist before that dialog moves them in the DOM.
--------------------------------------------------------- */
document.addEventListener('dialog:before-show', (event) => {
  event.target.querySelectorAll?.('template[data-deferred-content]').forEach((template) => {
    template.replaceWith(template.content);
  });
}, true);

/* ---------------------------------------------------------
   CLEAN OPTION LABELS
--------------------------------------------------------- */
function cleanOptionInfoSpans() {
  document.querySelectorAll('.variant-picker__option-info span').forEach((span) => {
    const originalText = span.textContent.trim();
    const cleanedText = originalText.replace(/\s?\(.*$/, '').trim();
    if (originalText !== cleanedText) span.textContent = cleanedText;
  });
}

/* ---------------------------------------------------------
   VALIDATE SECOND OPTION (SIDE COLOR)
--------------------------------------------------------- */
function validateSideColor() {
  const fieldsets = document.querySelectorAll('.variant-picker fieldset');
  if (fieldsets.length < 2) return; // prevent warnings

  const sideOptionInputs = fieldsets[1].querySelectorAll('input[type="radio"]');
  if (!sideOptionInputs.length) return;

  const selected = Array.from(sideOptionInputs).find((input) => input.checked);
  if (!selected) return;

  const selectedLabel = document.querySelector(`label[for="${selected.id}"]`);
  const disabled =
    selected.disabled ||
    selectedLabel?.classList.contains('is-disabled') ||
    selectedLabel?.getAttribute('aria-disabled') === 'true';

  if (!disabled) return;

  const fallback = Array.from(sideOptionInputs).find((input) => {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const isDisabled =
      input.disabled ||
      label?.classList.contains('is-disabled') ||
      label?.getAttribute('aria-disabled') === 'true';
    return !isDisabled;
  });

  if (fallback) fallback.click();
}

/* ---------------------------------------------------------
   RUN ON LOAD + VARIANT CHANGE
--------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  cleanOptionInfoSpans();
  validateSideColor();
});

document.addEventListener('variant:change', () => {
  cleanOptionInfoSpans();
  validateSideColor();
});

/* =========================================================
   VARIANT BADGE SYSTEM (IMAGE VARIANT BADGE)
   - JS version (dynamic when user switches variants)
========================================================= */
(function () {

  function parseBadgeList(raw) {
    if (!raw) return [];
    return raw
      .split(/\r?\n/)
      .map(x => x.trim())
      .filter(Boolean)
      .map(x => x.toLowerCase());
  }

  function findProductVariantsData() {
    const productEl = document.querySelector('.product');
    if (!productEl) return [];
    try { return JSON.parse(productEl.dataset.productVariants || "[]"); }
    catch { return []; }
  }

  function getVariantById(variants, id) {
    const vid = parseInt(id, 10);
    return variants.find(v => Number(v.id) === vid);
  }

  function updateBadgeForVariant(variant) {
    document.querySelectorAll('.product-gallery__media .auto-badge').forEach(n => n.remove());
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;

    const mediaId = variant.featured_media.id;
    const mediaEl = document.querySelector(`.product-gallery__media[data-media-id="${mediaId}"]`);
    if (!mediaEl) return;

    const gallery = document.querySelector('.product-gallery');
    const rawList = gallery?.dataset?.badgeList || "";
    const loweredList = parseBadgeList(rawList);

    const variantTitle = (variant.title || "").toLowerCase();

    let match = "";
    for (const key of loweredList) {
      if (variantTitle.includes(key)) {
        match = key;
        break;
      }
    }
    if (!match) return;

    const rawLines = rawList.split(/\r?\n/).map(x => x.trim()).filter(Boolean);
    let label = match;
    for (const orig of rawLines) {
      if (orig.toLowerCase() === match) label = orig;
    }

    const badge = document.createElement("div");
    badge.className = "auto-badge";
    badge.textContent = label;
    mediaEl.appendChild(badge);
  }

  function initBadgeSystem() {
    const gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    const variants = findProductVariantsData();

    document.addEventListener(
      "change",
      (e) => {
        const el = e.target;
        if (!el) return;
        if (
          el.name === "id" ||
          (el.getAttribute("name") || "").includes("-option")
        ) {
          setTimeout(() => {
            const form = document.querySelector('form[id^="product-form-"]') || document.querySelector('form');
            const sel = form?.querySelector('input[name="id"], select[name="id"]');
            const val = sel?.value || sel?.getAttribute("value");
            if (!val) return;
            const variant = getVariantById(variants, val);
            updateBadgeForVariant(variant);
          }, 100);
        }
      },
      true
    );

    document.addEventListener("variant:change", (e) => {
      updateBadgeForVariant(e.detail);
    });

    setTimeout(() => {
      const form = document.querySelector('form[id^="product-form-"]') || document.querySelector('form');
      const sel = form?.querySelector('input[name="id"], select[name="id"]');
      const val = sel?.value || sel?.getAttribute("value");
      const variant = val ? getVariantById(variants, val) : variants[0];
      updateBadgeForVariant(variant);
    }, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBadgeSystem);
  } else {
    initBadgeSystem();
  }

})();
